/** Visible navigation and workspace tabs. Not SP-Wiki article text. */
export const localeChrome = {
  'zh-TW': {
    navPaperLibrary: '論文庫',
    navNews: '新聞',
    navForum: '論壇',
    navRequestTemplate: '申請模板',
    navRequestDesign: '申請設計',
    navTeam: '團隊',
    navLiveSurveys: '線上調查',
    navResearcherLogin: '研究者登入',
    tabIntro: '簡介',
    tabMedia: '1. 媒體',
    tabBuilder: '2. 設計',
    tabShare: '3. 分享',
    tabResults: '4. 結果',
    tabPractice: '試填',
    tabSilicon: '矽基',
    builderSurveyLanguage: '問卷語言',
    builderSurveyLanguageHelp: '參與者看到的進度、輪次提示、下一頁／提交。預設為英文。',
    mediaTitle: '媒體資料集',
    builderTitle: '問卷設計',
  },
  ja: {
    navPaperLibrary: '論文ライブラリ',
    navNews: 'ニュース',
    navRequestTemplate: 'テンプレートを依頼',
    navRequestDesign: '設計を依頼',
    navTeam: 'チーム',
    navLiveSurveys: '公開中の調査',
    navResearcherLogin: '研究者ログイン',
    tabIntro: 'はじめに',
    tabMedia: '1. データ',
    tabBuilder: '2. 設計',
    tabShare: '3. 共有',
    tabResults: '4. 結果',
    tabPractice: '練習',
    tabSilicon: 'シリコン',
    builderSurveyLanguage: '調査の言語',
    builderSurveyLanguageHelp: '参加者に表示する進行、試行、次へ／完了。既定は英語です。',
    mediaTitle: 'メディアデータ',
    builderTitle: '調査の設計',
  },
  ko: {
    navPaperLibrary: '논문 라이브러리',
    navNews: '뉴스',
    navRequestTemplate: '템플릿 요청',
    navRequestDesign: '설계 요청',
    navTeam: '팀',
    navLiveSurveys: '진행 중인 조사',
    navResearcherLogin: '연구자 로그인',
    tabIntro: '소개',
    tabMedia: '1. 데이터',
    tabBuilder: '2. 설계',
    tabShare: '3. 공유',
    tabResults: '4. 결과',
    tabPractice: '연습',
    tabSilicon: '실리콘',
    builderSurveyLanguage: '설문 언어',
    builderSurveyLanguageHelp: '참여자에게 보이는 진행, 시행, 다음／완료. 기본값은 영어입니다.',
    mediaTitle: '미디어 데이터',
    builderTitle: '설문 설계',
  },
  fi: {
    navPaperLibrary: 'Julkaisukirjasto',
    navNews: 'Uutiset',
    navRequestTemplate: 'Pyydä mallia',
    navRequestDesign: 'Pyydä suunnittelua',
    navTeam: 'Tiimi',
    navLiveSurveys: 'Avoimet kyselyt',
    navResearcherLogin: 'Tutkijan kirjautuminen',
    tabIntro: 'Johdanto',
    tabMedia: '1. Aineisto',
    tabBuilder: '2. Rakentaja',
    tabShare: '3. Jako',
    tabResults: '4. Tulokset',
    tabPractice: 'Harjoitus',
    tabSilicon: 'Silicon',
    builderSurveyLanguage: 'Kyselyn kieli',
    builderSurveyLanguageHelp: 'Osallistujan edistyminen, kierrokset sekä Seuraava / Valmis. Oletus on englanti.',
    mediaTitle: 'Media-aineisto',
    builderTitle: 'Kyselyn rakentaja',
  },
  es: {
    navPaperLibrary: 'Biblioteca de artículos',
    navNews: 'Noticias',
    navRequestTemplate: 'Solicitar plantilla',
    navRequestDesign: 'Solicitar diseño',
    navTeam: 'Equipo',
    navLiveSurveys: 'Encuestas en curso',
    navResearcherLogin: 'Acceso de investigadores',
    tabIntro: 'Introducción',
    tabMedia: '1. Datos',
    tabBuilder: '2. Diseñador',
    tabShare: '3. Compartir',
    tabResults: '4. Resultados',
    tabPractice: 'Práctica',
    tabSilicon: 'Silicio',
    builderSurveyLanguage: 'Idioma de la encuesta',
    builderSurveyLanguageHelp: 'Progreso, ensayos y Siguiente / Finalizar que ve el participante. El valor predeterminado es inglés.',
    mediaTitle: 'Datos de medios',
    builderTitle: 'Diseñador de la encuesta',
  },
  fr: {
    navPaperLibrary: 'Bibliothèque d’articles',
    navNews: 'Actualités',
    navRequestTemplate: 'Demander un modèle',
    navRequestDesign: 'Demander une conception',
    navTeam: 'Équipe',
    navLiveSurveys: 'Enquêtes en cours',
    navResearcherLogin: 'Connexion chercheur',
    tabIntro: 'Introduction',
    tabMedia: '1. Médias',
    tabBuilder: '2. Conception',
    tabShare: '3. Partage',
    tabResults: '4. Résultats',
    tabPractice: 'Essai',
    tabSilicon: 'Silicium',
    builderSurveyLanguage: 'Langue du questionnaire',
    builderSurveyLanguageHelp: 'Progression, essais et Suivant / Terminer vus par le participant. L’anglais est la langue par défaut.',
    mediaTitle: 'Jeu de médias',
    builderTitle: 'Concepteur du questionnaire',
  },
  de: {
    navPaperLibrary: 'Publikationsbibliothek',
    navNews: 'Neuigkeiten',
    navRequestTemplate: 'Vorlage anfragen',
    navRequestDesign: 'Design anfragen',
    navTeam: 'Team',
    navLiveSurveys: 'Laufende Umfragen',
    navResearcherLogin: 'Forscheranmeldung',
    tabIntro: 'Einführung',
    tabMedia: '1. Medien',
    tabBuilder: '2. Editor',
    tabShare: '3. Teilen',
    tabResults: '4. Ergebnisse',
    tabPractice: 'Probelauf',
    tabSilicon: 'Silizium',
    builderSurveyLanguage: 'Umfragesprache',
    builderSurveyLanguageHelp: 'Fortschritt, Durchgänge und Weiter / Fertig für Teilnehmende. Standard ist Englisch.',
    mediaTitle: 'Mediendatensatz',
    builderTitle: 'Umfrage-Editor',
  },
  pt: {
    navPaperLibrary: 'Biblioteca de artigos',
    navNews: 'Notícias',
    navRequestTemplate: 'Pedir modelo',
    navRequestDesign: 'Pedir desenho',
    navTeam: 'Equipa',
    navLiveSurveys: 'Inquéritos em curso',
    navResearcherLogin: 'Entrada de investigador',
    tabIntro: 'Introdução',
    tabMedia: '1. Media',
    tabBuilder: '2. Editor',
    tabShare: '3. Partilhar',
    tabResults: '4. Resultados',
    tabPractice: 'Ensaio',
    tabSilicon: 'Silício',
    builderSurveyLanguage: 'Idioma do inquérito',
    builderSurveyLanguageHelp: 'Progresso, ensaios e Seguinte / Concluir vistos pelo participante. A predefinição é inglês.',
    mediaTitle: 'Dados de media',
    builderTitle: 'Editor do inquérito',
  },
};
